// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Home Button

gameRulesButton = {};

gameRulesButton.create = function () {
  var button = new PIXI.Container();

  this._sideMenuOpen = false;

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button.canEnable = function () {
    return this._sideMenuOpen;
  };

  button.canShow = function () {
    return true;
  };

  button.onPressedCallback = function () {
    let style = `<style>
                body {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    background: rgb(255,255,255);
                    word-wrap: break-word;
                    text-align: center;
                    touch-action: pan-y;
                    font-size: 1.2rem;
                    -webkit-text-size-adjust: 100%;
                    -moz-text-size-adjust: 100%;
                    -ms-text-size-adjust: 100%;
                }
                h1 {
                    color: #000000;
                }
                h3 {
                    color: #000000;
                }
                ul {
                    text-align: left;
                }
                p {
                    text-align: left;
                }
              </style>`;
    messageBus.postImmediate('ui:modal', { reason: 'Game Rules open' });
    let gameRulestText = gdk.translateText('gameRules', []);
    htmlViewer.show(`${style}${gameRulestText}`, 't_settings_close', true);
    if (button.soundName !== '') button.playSound();
  };

  button.sideMenuOpenMsg = function () {
    this._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    this._sideMenuOpen = false;
  };

  messageBus.subscribe('game:sideMenuOpen', button.sideMenuOpenMsg.bind(button));
  messageBus.subscribe('game:sideMenuClosed', button.sideMenuClosedMsg.bind(button));

  return button;
};

gameRulesButton.initialise = function (json, object) {
  object.soundName = json.soundName || '';
  if (checkForDefined(json.translationPhrase)) {
    button._closeButtonTranslationPhrase = json.closeButtonTranslationPhrase;
  }
};

gameRulesButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'gameRulesStringButton',
  gameRulesButton.create,
  gameRulesButton.initialise,
  gameRulesButton.getFilesRequired
);
